export default "__VITE_ASSET__DLzOie3y__"